import * as TurboModuleRegistry from "../TurboModule/TurboModuleRegistry";
var NativeAnimatedModule_default = TurboModuleRegistry.get("NativeAnimatedModule");
export {
  NativeAnimatedModule_default as default
};
//# sourceMappingURL=NativeAnimatedModule.js.map
